export const useStyles = theme => ({
  divider: {
    borderTop: '2px solid',
    marginBottom: '20px',
    marginTop: '20px',
  },
});
